module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/76121b7f4eff7d7ca0d49a45479d3f3f.svg";